module.exports = __webpack_public_path__ + "img/shg45_samurai02skin_shop.d43caa26.png";